import mutations from './doctorConsultConfig.mutations'
import actions from './doctorConsultConfig.actions'
import getters from './doctorConsultConfig.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
